import {Action, ActionReducer, ActionReducerMap, createAction, MetaReducer} from '@ngrx/store';
import {localStorageSync} from 'ngrx-store-localstorage';
import {utils} from '../../modules/global';

export interface State {}

export const reducers: ActionReducerMap<State> = {};

export const localStorageSyncReducer = (
  reducer: ActionReducer<any>
): ActionReducer<any> => localStorageSync({
    keys: [{ global: ['refreshToken', 'language']}],
    rehydrate: true
  })(reducer);

const logoutActionType = '[GLOBAL ACTION] logout';
const companyChangeActionType = '[GLOBAL ACTION] companyChange';
export class LogoutAction implements Action {
  public readonly type = logoutActionType;
  constructor() {}
}
export const rootStoreActions = {
  logoutAction : createAction(logoutActionType),
  companyChangeAction : createAction(companyChangeActionType)
};

export const logoutPlugin = (reducer: ActionReducer<any>): ActionReducer<any> => (state, action) => {
  switch (action.type) {
    case rootStoreActions.logoutAction.type:
      state = {};
      break;
    case rootStoreActions.companyChangeAction.type:
      state = {
        global: utils.pick(state?.global ?? {},
          ['user', 'isAuthenticated', 'company', 'general', 'notification', 'authToken', 'refreshToken', 'language'])
      };
      break;
  }
  return reducer(state, action);
};

export const metaReducers: MetaReducer<State>[] = [
  localStorageSyncReducer,
  logoutPlugin
];
